const GeneralActionTypes = {
  IS_EDIT_DETAILS_START: "is_edit_details_start",
  IS_OPEN_OFFCANVAS_START: "is_open_offcanvas_start",

  /** ***************** GET COUNTRY LIST START *********************** */
  GET_COUNTRY_LIST_START: "get_country_list_start",
  GET_COUNTRY_LIST_SUCCESS: "get_country_list_success",
  GET_COUNTRY_LIST_FAILURE: "get_country_list_failure",
  GET_COUNTRY_LIST_RESPONSE_RESET: "get_country_list_response_reset",
  GET_COUNTRY_LIST_RESPONSE_CHANGED: "get_country_list_response_changed",
  /** ***************** GET COUNTRY LIST END *********************** */

  /** ***************** FETCH ALL BRANCHES LIST START *********************** */
  FETCH_ALL_BRANCHES_START: "fetch_all_branches_start",
  FETCH_ALL_BRANCHES_SUCCESS: "fetch_all_branches_success",
  FETCH_ALL_BRANCHES_FAILURE: "fetch_all_branches_failure",
  FETCH_ALL_BRANCHES_RESPONSE_RESET_START: "fetch_all_branches_response_reset",
  FETCH_ALL_BRANCHES_RESPONSE_CHANGED: "fetch_all_branches_response_changed",
  /** ***************** FETCH ALL BRANCHES LIST END *********************** */

  /** ***************** FETCH PINCODE DETAILS START *********************** */
  FETCH_PINCODE_DETAILS_START: "fetch_pincode_details_Start",
  FETCH_PINCODE_DETAILS_SUCCESS: "fetch_pincode_details_Success",
  FETCH_PINCODE_DETAILS_FAILURE: "fetch_pincode_details_Failure",
  FETCH_PINCODE_DETAILS_RESPONSE_RESET: "fetch_pincode_details_Response_Reset",
  FETCH_PINCODE_DETAILS_RESPONSE_CHANGED:
    "fetch_pincode_details_Response_Changed",
  /** ***************** FETCH PINCODE DETAILS END *********************** */

  /**************FETCH CONTRY COUNTRY LIST ************************/
  FETCH_COUNTRY_LIST_START: "fetch_country_list_start",
  FETCH_COUNTRY_LIST_SUCCESS: "fetch_country_list_success",
  FETCH_COUNTRY_LIST_FAILURE: "fetch_country_list_failure",
  FETCH_COUNTRY_LIST_RESPONSE_RESET: "fetch_country_list_response_reset",
  FETCH_COUNTRY_LIST_RESPONSE_CHANGED: "fetch_country_list_response_changed",
  /**************FETCH CONTRY COUNTRY LIST ************************/

  /**************FETCH CONTRY COUNTRY STATE LIST ************************/
  FETCH_COUNTRY_LIST_STATE_START: "fetch_country_list_state_start",
  FETCH_COUNTRY_LIST_STATE_SUCCESS: "fetch_country_list_state_success",
  FETCH_COUNTRY_LIST_STATE_FAILURE: "fetch_country_list_state_failure",
  FETCH_COUNTRY_LIST_STATE_RESPONSE_RESET:
    "fetch_country_list_state_response_reset",
  FETCH_COUNTRY_LIST_STATE_RESPONSE_CHANGED:
    "fetch_country_list_state_response_changed",
  /**************FETCH CONTRY COUNTRY STATE LIST ************************/

  /**************FETCH STATE CITY LIST ************************/
  FETCH_STATE_CITY_LIST_START: "fetch_state_city_list_start",
  FETCH_STATE_CITY_LIST_SUCCESS: "fetch_state_city_list_success",
  FETCH_STATE_CITY_LIST_FAILURE: "fetch_state_city_list_failure",
  FETCH_STATE_CITY_LIST_RESPONSE_RESET: "fetch_state_city_list_response_reset",
  FETCH_STATE_CITY_LIST_RESPONSE_CHANGED:
    "fetch_state_city_list_response_changed",
  /**************FETCH CITY  LIST ************************/
};

export default GeneralActionTypes;
